import { RootState } from "@lhd/app/store";
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { IProjectTask } from "types/projectManager/task";

type IMeetingInitialStates = {
  delayedTasks: IProjectTask[];
  scheduledTasks: IProjectTask[];
};

const initialState: IMeetingInitialStates = {
  delayedTasks: [],
  scheduledTasks: [],
};

const meetingSlice = createSlice({
  name: "meeting",
  initialState,
  reducers: {
    getListProjectTasks(
      state,
      action: PayloadAction<{ tasks: IProjectTask[] }>,
    ) {
      action.payload.tasks.forEach((task) => {
        if (task.end_date && dayjs(task.end_date).isBefore(dayjs(), "day")) {
          state.delayedTasks.push(task);
        }

        if (task.start_date && dayjs(task.start_date).isAfter(dayjs(), "day")) {
          state.scheduledTasks.push(task);
        }
      });
    },
  },
});

export const { getListProjectTasks } = meetingSlice.actions;

const meetingSelector = (state: RootState) => state.meeting;

export const getDelayedTasks = createSelector(
  meetingSelector,
  (state) => state.delayedTasks,
);
export const getScheduledTasks = createSelector(
  meetingSelector,
  (state) => state.scheduledTasks,
);

export default meetingSlice;
